"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore file */

/** Internal use enum for establishing the client side deferment pattern */
var DefermentType;

(function (DefermentType) {
  DefermentType["COMPLETE_SKIP"] = "COMPLETE_SKIP";
  DefermentType["HYDRATE_INLINE_SLOW"] = "HYDRATE_INLINE_SLOW";
  DefermentType["HYDRATE_ON_TIMER"] = "HYDRATE_ON_TIMER";
  DefermentType["HYDRATE_ON_VISIBLE"] = "HYDRATE_ON_VISIBLE";
  DefermentType["NEVER_HYDRATE"] = "NEVER_HYDRATE";
})(DefermentType || (DefermentType = {}));

var _default = DefermentType;
exports.default = _default;